const Load_Data_Action = (data) => {
  console.log("Load_Data_Action "+data);
  return { type: "DATA_LOADED", data: data };
};
const UpdateData = (data) => {
  console.log("actions");
  return { type: "DATA_UPDATED", data: data };
};
const Login_Success_Action = (data) => {
  console.log("Login_Success_Action "+data);
  return { type: "LOGIN_SUCCESS", data: data };
};
const Logout_Succes_Action = (data) => {
  console.log("Logout_Succes_Action "+data);
  return { type: "LOGIN_SUCCESS", data: data };
};
export { Load_Data_Action, UpdateData ,Login_Success_Action,Logout_Succes_Action};
